import { MIN_SINGLE_CARDS, MIN_PAIRS, MIN_TRIPLES, select, uniqueMoves } from './moveConstants';

export class MovesGener {
    constructor(cardsList) {
        this.cardsList = cardsList;
        this.cardsDict = {};
        cardsList.forEach((c) => {
            this.cardsDict[c] = (this.cardsDict[c] || 0) + 1;
        });
        this.singleCardMoves = [];
        this.genType1Single();
        this.pairMoves = [];
        this.genType2Pair();
        this.tripleCardsMoves = [];
        this.genType3Triple();
        this.bombMoves = [];
        this.genType4Bomb();
        this.finalBombMoves = [];
        this.genType5KingBomb();
    }

    _genSerialMoves(cards, minSerial, repeat = 1, repeatNum = 0) {
        if (repeatNum < minSerial) repeatNum = 0;

        const singleCards = [...new Set(cards)].sort((a, b) => a - b);
        const seqRecords = [];
        const moves = [];

        let start = 0;
        let i = 0;
        let longest = 1;
        while (i < singleCards.length) {
            if (i + 1 < singleCards.length && singleCards[i + 1] - singleCards[i] === 1) {
                longest += 1;
                i += 1;
            } else {
                seqRecords.push([start, longest]);
                i += 1;
                start = i;
                longest = 1;
            }
        }

        seqRecords.forEach((seq) => {
            if (seq[1] < minSerial) return;
            const seqStart = seq[0];
            const seqLen = seq[1];
            const longestList = singleCards.slice(seqStart, seqStart + seqLen);

            if (repeatNum === 0) {
                let steps = minSerial;
                while (steps <= seqLen) {
                    let index = 0;
                    while (steps + index <= seqLen) {
                        const slice = longestList.slice(index, index + steps);
                        const targetMoves = slice
                            .flatMap((c) => Array(repeat).fill(c))
                            .sort((a, b) => a - b);
                        moves.push(targetMoves);
                        index += 1;
                    }
                    steps += 1;
                }
            } else if (seqLen >= repeatNum) {
                let index = 0;
                while (index + repeatNum <= seqLen) {
                    const slice = longestList.slice(index, index + repeatNum);
                    const targetMoves = slice
                        .flatMap((c) => Array(repeat).fill(c))
                        .sort((a, b) => a - b);
                    moves.push(targetMoves);
                    index += 1;
                }
            }
        });

        return moves;
    }

    genType1Single() {
        this.singleCardMoves = [...new Set(this.cardsList)].map((i) => [i]);
        return this.singleCardMoves;
    }

    genType2Pair() {
        this.pairMoves = [];
        Object.entries(this.cardsDict).forEach(([k, v]) => {
            if (v >= 2) this.pairMoves.push([Number(k), Number(k)]);
        });
        return this.pairMoves;
    }

    genType3Triple() {
        this.tripleCardsMoves = [];
        Object.entries(this.cardsDict).forEach(([k, v]) => {
            if (v >= 3) this.tripleCardsMoves.push([Number(k), Number(k), Number(k)]);
        });
        return this.tripleCardsMoves;
    }

    genType4Bomb() {
        this.bombMoves = [];
        Object.entries(this.cardsDict).forEach(([k, v]) => {
            if (v === 4) this.bombMoves.push([Number(k), Number(k), Number(k), Number(k)]);
        });
        return this.bombMoves;
    }

    genType5KingBomb() {
        this.finalBombMoves = [];
        if (this.cardsList.includes(20) && this.cardsList.includes(30)) {
            this.finalBombMoves.push([20, 30]);
        }
        return this.finalBombMoves;
    }

    genType6_3_1() {
        const result = [];
        this.singleCardMoves.forEach((t) => {
            this.tripleCardsMoves.forEach((triple) => {
                if (t[0] !== triple[0]) result.push([...t, ...triple]);
            });
        });
        return result;
    }

    genType7_3_2() {
        const result = [];
        this.pairMoves.forEach((t) => {
            this.tripleCardsMoves.forEach((triple) => {
                if (t[0] !== triple[0]) result.push([...t, ...triple]);
            });
        });
        return result;
    }

    genType8SerialSingle(repeatNum = 0) {
        return this._genSerialMoves(this.cardsList, MIN_SINGLE_CARDS, 1, repeatNum);
    }

    genType9SerialPair(repeatNum = 0) {
        const singlePairs = Object.entries(this.cardsDict)
            .filter(([, v]) => v >= 2)
            .map(([k]) => Number(k));
        return this._genSerialMoves(singlePairs, MIN_PAIRS, 2, repeatNum);
    }

    genType10SerialTriple(repeatNum = 0) {
        const singleTriples = Object.entries(this.cardsDict)
            .filter(([, v]) => v >= 3)
            .map(([k]) => Number(k));
        return this._genSerialMoves(singleTriples, MIN_TRIPLES, 3, repeatNum);
    }

    genType11Serial3_1(repeatNum = 0) {
        const serial3Moves = this.genType10SerialTriple(repeatNum);
        const serial31Moves = [];
        serial3Moves.forEach((s3) => {
            const s3Set = new Set(s3);
            const newCards = this.cardsList.filter((i) => !s3Set.has(i));
            const subcards = select(newCards, s3Set.size);
            subcards.forEach((i) => serial31Moves.push([...s3, ...i]));
        });
        return uniqueMoves(serial31Moves);
    }

    genType12Serial3_2(repeatNum = 0) {
        const serial3Moves = this.genType10SerialTriple(repeatNum);
        const serial32Moves = [];
        const pairSet = Object.entries(this.cardsDict)
            .filter(([, v]) => v >= 2)
            .map(([k]) => Number(k))
            .sort((a, b) => a - b);
        serial3Moves.forEach((s3) => {
            const s3Set = new Set(s3);
            const pairCandidates = pairSet.filter((i) => !s3Set.has(i));
            const subcards = select(pairCandidates, s3Set.size);
            subcards.forEach((i) => {
                serial32Moves.push([...s3, ...i.flatMap((c) => [c, c])].sort((a, b) => a - b));
            });
        });
        return serial32Moves;
    }

    genType13_4_2() {
        const fourCards = Object.entries(this.cardsDict)
            .filter(([, v]) => v === 4)
            .map(([k]) => Number(k));
        const result = [];
        fourCards.forEach((fc) => {
            const cardsList = this.cardsList.filter((k) => k !== fc);
            select(cardsList, 2).forEach((i) => result.push([fc, fc, fc, fc, ...i]));
        });
        return uniqueMoves(result);
    }

    genType14_4_22() {
        const fourCards = Object.entries(this.cardsDict)
            .filter(([, v]) => v === 4)
            .map(([k]) => Number(k));
        const result = [];
        fourCards.forEach((fc) => {
            const cardsList = Object.entries(this.cardsDict)
                .filter(([k, v]) => Number(k) !== fc && v >= 2)
                .map(([k]) => Number(k));
            select(cardsList, 2).forEach((i) => {
                result.push([fc, fc, fc, fc, i[0], i[0], i[1], i[1]]);
            });
        });
        return result;
    }

    genMoves() {
        return [
            ...this.genType1Single(),
            ...this.genType2Pair(),
            ...this.genType3Triple(),
            ...this.genType4Bomb(),
            ...this.genType5KingBomb(),
            ...this.genType6_3_1(),
            ...this.genType7_3_2(),
            ...this.genType8SerialSingle(),
            ...this.genType9SerialPair(),
            ...this.genType10SerialTriple(),
            ...this.genType11Serial3_1(),
            ...this.genType12Serial3_2(),
            ...this.genType13_4_2(),
            ...this.genType14_4_22(),
        ];
    }
}
